import React from 'react';
import { Box, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface BlogTagsProps {
  tags: string[];
  clickable?: boolean;
}

export const BlogTags: React.FC<BlogTagsProps> = ({ tags, clickable = true }) => {
  const navigate = useNavigate();

  if (tags.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {tags.map((tag) => (
        <Chip
          key={tag}
          label={tag}
          size="small"
          variant="outlined"
          onClick={clickable ? () => navigate(`/blog/tag/${encodeURIComponent(tag)}`) : undefined}
          sx={{
            cursor: clickable ? 'pointer' : 'default',
            '&:hover': clickable
              ? {
                  bgcolor: 'primary.light',
                  color: 'primary.contrastText',
                  borderColor: 'primary.main',
                }
              : undefined,
          }}
        />
      ))}
    </Box>
  );
};

export default BlogTags;
